import { render } from "./NewMasternodeList.vue?vue&type=template&id=05c5c9e8"
import script from "./NewMasternodeList.vue?vue&type=script&setup=true&lang=js"
export * from "./NewMasternodeList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/masternode/NewMasternodeList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05c5c9e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05c5c9e8', __exports__)) {
    api.reload('05c5c9e8', __exports__)
  }
  
  module.hot.accept("./NewMasternodeList.vue?vue&type=template&id=05c5c9e8", () => {
    api.rerender('05c5c9e8', render)
  })

}


export default __exports__